/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cad_Confirmed_By_RequiredInputs */

const en_cad_confirmed_by_required = /** @type {(inputs: Cad_Confirmed_By_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter the name or phone number of the customer who confirmed the new date.`)
};

const ja_cad_confirmed_by_required = /** @type {(inputs: Cad_Confirmed_By_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新しい日程を確認した顧客の氏名または電話番号を入力してください。`)
};

const fr_cad_confirmed_by_required = /** @type {(inputs: Cad_Confirmed_By_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indiquez le nom ou le numéro de téléphone du client qui a confirmé la nouvelle date.`)
};

const de_cad_confirmed_by_required = /** @type {(inputs: Cad_Confirmed_By_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geben Sie den Namen oder die Telefonnummer des Kunden an, der den neuen Termin bestätigt hat.`)
};

/**
* | output |
* | --- |
* | "Enter the name or phone number of the customer who confirmed the new date." |
*
* @param {Cad_Confirmed_By_RequiredInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const cad_confirmed_by_required = /** @type {((inputs?: Cad_Confirmed_By_RequiredInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cad_Confirmed_By_RequiredInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cad_confirmed_by_required(inputs)
	if (locale === "ja") return ja_cad_confirmed_by_required(inputs)
	if (locale === "fr") return fr_cad_confirmed_by_required(inputs)
	return de_cad_confirmed_by_required(inputs)
});